import { useState as useReactState } from 'react';
import { useActions } from '../hooks/useApi';
import { SectionHeader } from '../components/ui/section-header';
import { ActionsTable } from '../components/actions-table';

const KIND_FILTERS = [
  'all',
  'auto_hedge',
  'auto_harvest',
  'auto_redeploy',
  'hedge_order',
] as const;
const STATUS_FILTERS = ['all', 'confirmed', 'failed', 'pending'] as const;

type KindFilter = (typeof KIND_FILTERS)[number];
type StatusFilter = (typeof STATUS_FILTERS)[number];

export default function Actions() {
  const [kind, setKind] = useReactState<KindFilter>('all');
  const [status, setStatus] = useReactState<StatusFilter>('all');
  const { data: actions, error } = useActions(500);

  if (error) {
    return (
      <div className="rounded-lg border border-border bg-surface p-6 text-sm text-negative">
        {error.message}
      </div>
    );
  }

  const filtered = (actions ?? []).filter((r) => {
    if (kind !== 'all' && r.kind !== kind) return false;
    if (status !== 'all' && r.status !== status) return false;
    return true;
  });

  return (
    <div className="space-y-6 max-w-7xl">
      <SectionHeader
        title="Actions"
        subtitle={`${filtered.length}${actions ? ` / ${actions.length}` : ''} rows in audit trail`}
        size="lg"
        actions={
          <div className="flex gap-2 text-xs">
            <select
              value={kind}
              onChange={(e) => setKind(e.target.value as KindFilter)}
              className="h-9 border border-border rounded-md px-3 bg-surface text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            >
              {KIND_FILTERS.map((k) => (
                <option key={k} value={k}>
                  kind: {k}
                </option>
              ))}
            </select>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value as StatusFilter)}
              className="h-9 border border-border rounded-md px-3 bg-surface text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            >
              {STATUS_FILTERS.map((s) => (
                <option key={s} value={s}>
                  status: {s}
                </option>
              ))}
            </select>
          </div>
        }
      />

      <ActionsTable
        rows={filtered}
        pageSize={25}
        emptyMessage={
          actions && actions.length > 0
            ? 'No actions match the current filters.'
            : 'No actions yet.'
        }
      />
    </div>
  );
}
